// src/components/LayoutHeader.js
import React, { useState, useEffect } from 'react';
import logo from '../img/logo.png';

const LayoutHeader = ({ onNavigate, currentPage }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleNavLinkClick = (page) => {
    onNavigate(page);
    setIsMenuOpen(false);
  };

  const navItems = [
    { name: 'Inicio', page: 'inicio' },
    { name: 'Servicios', page: 'servicios' },
    { name: 'Experiencia', page: 'experiencia' },
    { name: 'Sobre Nosotros', page: 'sobreMi' },  
    { name: 'Testimonios', page: 'testimonios' },
    { name: 'Contacto', page: 'contacto' },
  ];

  return (
    <header className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-[#211F1F] shadow-lg' : 'bg-transparent'}`}>
      <div className="container mx-auto px-4 py-4 flex justify-between items-center">
        {/* Logo y nombre de la empresa */}
        <div className="flex items-center min-w-0 flex-1">
          <img src={logo} alt="Logo" className="h-12 md:h-16 w-auto mr-2 md:mr-3 flex-shrink-0" />
          <div className="flex flex-col justify-center min-w-0">
            {/* Nombre de la empresa - responsivo sin saltos forzados */}
            <span className="text-sm sm:text-base md:text-lg lg:text-xl font-bold text-[#E8B00C] leading-tight whitespace-normal break-words">
              Consultores Evelio Bustos Apache SAS
            </span>
            <span className="text-xs sm:text-sm text-white font-normal">
              Ética, Calidad y Compromiso
            </span>
          </div>
        </div>
        
        {/* Navegación Desktop */}
        <nav className="hidden md:flex space-x-6 lg:space-x-8">
          {navItems.map((item) => (
            <button
              key={item.page}
              onClick={() => handleNavLinkClick(item.page)}
              className={`font-medium transition-colors text-sm lg:text-base ${
                currentPage === item.page ? 'text-white border-b-2 border-[#E8B00C]' : 'text-[#E8B00C] hover:text-white'
              }`}
            >
              {item.name}
            </button>
          ))}
        </nav>
        
        {/* Botón menú móvil */}
        <div className="md:hidden">
          <button onClick={toggleMenu} className="text-[#E8B00C] focus:outline-none">
            <svg className="w-7 h-7 sm:w-8 sm:h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              {isMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path>
              )}
            </svg>
          </button>
        </div>
      </div>
      
      {/* Menú móvil desplegable */}
      {isMenuOpen && (
        <div className="md:hidden bg-[#211F1F] shadow-lg pb-4">
          <nav className="flex flex-col items-center space-y-4">
            {navItems.map((item) => (
              <button
                key={item.page}
                onClick={() => handleNavLinkClick(item.page)}
                className={`font-medium transition-colors w-full py-2 text-center ${
                  currentPage === item.page ? 'text-white border-l-4 border-[#E8B00C]' : 'text-[#E8B00C] hover:text-white'
                }`}
              >
                {item.name}
              </button>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
};

export default LayoutHeader;